var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroidBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 41,
    height: 41,
    rx: 5,
    stroke: "#231F20",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0756 9.62498C10.7635 9.99948 10.6056 10.4788 10.6341 10.9655V32.1084C10.6072 32.5949 10.7649 33.0736 11.0756 33.4489L11.1479 33.5212L22.9876 21.6734V21.3925L11.1479 9.55273L11.0756 9.62498Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6797 25.6236L24.7305 21.6743V21.3934L28.6797 17.4521L28.768 17.5003L33.4477 20.1572C34.7882 20.9118 34.7882 22.1559 33.4477 22.9185L28.768 25.5754L28.6797 25.6236Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8968 26.4451L23.8833 22.4316L11.9473 34.3195C12.2224 34.5457 12.5649 34.674 12.921 34.6842C13.277 34.6944 13.6263 34.5858 13.9139 34.3757L27.8727 26.4451",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8968 16.6288L13.9139 8.69016C13.6294 8.47143 13.2777 8.35825 12.9191 8.36997C12.5604 8.38168 12.2169 8.51755 11.9473 8.75438L23.8592 20.6664L27.8968 16.6288Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M11.9465 33.3202C11.6352 32.9421 11.4776 32.4607 11.505 31.9717V32.1081C11.4781 32.5946 11.6358 33.0733 11.9465 33.4486L12.0187 33.3764L11.9465 33.3202Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M32.5766 22.7731L27.8086 25.4862L27.8969 25.5745L32.5766 22.8855C32.8511 22.7648 33.0886 22.5734 33.2649 22.3308C33.4412 22.0883 33.5499 21.8032 33.58 21.5049C33.5252 21.7807 33.4057 22.0395 33.2312 22.26C33.0568 22.4805 32.8324 22.6564 32.5766 22.7731Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.9139 9.70538L32.5766 20.2929C32.8299 20.4068 33.0527 20.5788 33.2271 20.795C33.4014 21.0112 33.5223 21.2654 33.5799 21.5371C33.5515 21.2382 33.4434 20.9525 33.267 20.7096C33.0905 20.4668 32.8521 20.2758 32.5766 20.1565L13.9139 9.5609C12.5975 8.80636 11.5059 9.43246 11.5059 10.9656V11.1021C11.5059 9.57695 12.5975 8.94282 13.9139 9.70538Z",
    fill: "#231F20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidBlack);
export default __webpack_public_path__ + "static/media/android-black.9652db6e483eef8a15301181dffcb98c.svg";
export { ForwardRef as ReactComponent };